var _defs, _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectLiability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.52 43.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M11.987 34.024s-.365.81.576 1.75l2.762 2.762c1.616 1.616 2.311.636 3.57-.623s2.239-1.955.623-3.57l-2.762-2.762c-.94-.94-1.75-.576-1.75-.576M11.923 28.003s.364-.809-.576-1.75l-2.762-2.762c-1.616-1.616-2.311-.636-3.569.622s-2.238 1.953-.622 3.569l2.762 2.762c.94.94 1.75.576 1.75.576"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M9.262 28.293l5.581 5.581M30.765 11.647c.637.423 1.259.633 2.427 1.993 1.705 1.985 1.752 4.735 1.752 4.735l3.52 1.233v5.555l-3.721 1.367s-.596 1.642-1.724 2.647c-1.156 1.029-2.452 1.592-2.452 1.592l-.784 3.502h-3.49l-.663-3.116h-1.829M13.253 11.647c-2.092 1.486-3.605 3.139-4.486 5.925M26.042 15.205h-7.835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M18.134 10.288a4.582 4.582 0 118.441-2.566 4.56 4.56 0 01-.76 2.624"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 29.721,
    cy: 18.655,
    r: 1.501
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectLiability);
export default __webpack_public_path__ + "static/media/connectLiability.f2b2d34066cc400a7cee9388653fe89e.svg";
export { ForwardRef as ReactComponent };